import React, { useEffect, useState } from "react";
import "./EqualizerMotion.css";

const PATTERNS = [
  [[3], [2], [4]],
  [[2], [3], [4]],
  [[4], [2], [3]],
  [[4], [2], [4]],
  [[2], [4], [3]],
  [[2], [4], [4]],
];

const MAX_BARS = 4;

const EqualizerMotion = () => {
  const [currentPatternIndex, setCurrentPatternIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPatternIndex((prev) => (prev + 1) % PATTERNS.length);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const currentPattern = PATTERNS[currentPatternIndex];

  return (
    <div className="flex gap-[4px] sm:gap-[6px] md:gap-[8px] lg:gap-[10px] items-end">
      {currentPattern.map((col, colIdx) => {
        const barCount = col[0];

        return (
          <div
            key={colIdx}
            className="flex flex-col justify-end gap-[3px] sm:gap-[4px] min-h-[30px] sm:min-h-[36px] md:min-h-[40px]"
          >
            {Array.from({ length: MAX_BARS }).map((_, rowIdx) => {
              const isVisible = rowIdx >= MAX_BARS - barCount;
              const isBottom = rowIdx === MAX_BARS - 1;

              const animationClass =
                barCount === MAX_BARS && !isBottom
                  ? "bar-shake"
                  : isVisible && !isBottom
                  ? "bar-fade"
                  : isBottom
                  ? "bottom-fixed"
                  : "opacity-0";

              return (
                <div
                  key={rowIdx}
                  className={`rounded ${animationClass}`}
                  style={{
                    height: isBottom ? "4px" : "4px",
                    width: "clamp(10px, 3vw, 20px)",
                    background: isVisible
                      ? isBottom
                        ? "#3F8ED2"
                        : "linear-gradient(90deg, #1A75CF, #197AD0)"
                      : "transparent",
                  }}
                />
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default EqualizerMotion;
